// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"708":"08f6904b","962":"f8e9115a"}[chunkId] + ".css";
};